import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const StyledNotificationTypography = styled(Typography)({
  fontSize: "16px",
  fontWeight: 300,
});
